import { Artist, ARTIST } from '@favid-inc/api';
import { Get } from '@favid-inc/api/lib/rest';
import { Action, instanceOfMessage, stateReducerFactory } from 'core/generic';
import { MESSAGE_ERROR } from 'core/redux/types';
import { BEFORE_FETCH_ORDERS, ON_ERROR_FETCH_ORDERS, ON_FETCH_ORDERS } from 'features/orders';
import { request as client } from 'utils';
import { registerMessage } from 'utils/message';
import { ArtistOrdersState } from './ArtistOrders';
import { BEFORE_FETCH_ARTIST, ERROR_FETCH_ARTIST_DESC, ON_ERROR_FETCH_ARTIST, ON_FETCH_ARTIST } from './types';

export const artistDetailsReducer = (state: { isLoading: boolean }, { type, payload }: Action) => {
  switch (type) {
    case ON_FETCH_ARTIST:
      return { isLoading: false, artist: payload };
    case ON_ERROR_FETCH_ARTIST:
      if (payload && instanceOfMessage(payload)) {
        registerMessage(payload);
      }
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

export const artistOrdersReducer = (initialState: ArtistOrdersState) => {
  return stateReducerFactory({
    initialState,
    beforeProcessing: BEFORE_FETCH_ORDERS,
    onError: ON_ERROR_FETCH_ORDERS,
    onFetch: ON_FETCH_ORDERS,
  });
};

export const fetchArtist = async (id: Artist['id'], dispatch: (action: Action) => void) => {
  dispatch({
    type: BEFORE_FETCH_ARTIST,
  });

  try {
    const request: Get<Artist>['Request'] = {
      url: `/${ARTIST}/${id}`,
      method: 'GET',
    };

    const response = await client.request<Get<Artist>['Response']>(request);
    dispatch({
      type: ON_FETCH_ARTIST,
      payload: response.data,
    });
  } catch (error) {
    const response = {
      description: ERROR_FETCH_ARTIST_DESC,
      type: MESSAGE_ERROR,
    };
    dispatch({
      type: ON_FETCH_ARTIST,
      payload: response,
    });
  }
};
